/**
 * Client-safe i18n primitives. NO `next/headers` here — this module is
 * imported by client components (LanguageToggle, LocaleProvider).
 *
 * Server-only helpers (cookie reader) live in `lib/i18n-server.ts`.
 */

export type Lang = "en" | "es";
export type Bilingual = { en: string; es: string };

export const LANG_COOKIE = "nysg_lang";
export const LANG_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function isLang(value: unknown): value is Lang {
  return value === "en" || value === "es";
}

/** Pick the right side of a `Bilingual` for a given language. */
export function pick(s: Bilingual, lang: Lang): string {
  return s[lang];
}

/** Curry a translator bound to a fixed language. */
export function tFor(lang: Lang) {
  return (s: Bilingual): string => s[lang];
}

/** HTML `lang` attribute per locale (en gets en-US for US-English signal). */
export function htmlLang(lang: Lang): string {
  return lang === "es" ? "es" : "en-US";
}
